import React from 'react';

const Leadership = () => {
    return (
        <div>
            Sorry, This page is not ready yet
        </div>
    );
};

export default Leadership;